var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgLesson = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7001 8.9L13.4001 9.2C12.6001 9.2 11.9001 8.7 11.9001 7.9L11.6001 5.5H11.7001L15.7001 8.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6002 17.7016C16.7002 18.5016 16.1002 19.2016 15.4002 19.2016L7.9002 20.0016H7.8002H7.6002C6.8002 20.1016 6.1002 19.5016 6.1002 18.8016L5.0002 7.60156C4.9002 6.80156 5.5002 6.10156 6.2002 6.10156L11.5002 5.60156H11.6002L11.8002 7.90156C11.8002 8.10156 11.9002 8.30156 12.0002 8.40156C12.1002 8.50156 12.2002 8.70156 12.3002 8.80156C12.6002 9.10156 13.0002 9.20156 13.4002 9.20156H13.6002H13.7002L15.7002 9.00156L16.6002 17.7016Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3003 8.90156L15.9003 9.00156H15.8003L14.0003 9.20156C13.9003 9.20156 13.8003 9.20156 13.8003 9.20156C13.1003 9.20156 12.6003 8.60156 12.5003 8.00156L12.3003 6.10156V6.00156V5.60156H12.4003L16.3003 8.90156Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 17.7016C16.7003 18.5016 16.1003 19.2016 15.4003 19.2016L7.9003 20.0016C7.3003 19.9016 6.7003 19.4016 6.7003 18.8016L5.6003 7.60156C5.5003 6.80156 6.1003 6.10156 6.8003 6.10156L11.6003 5.60156H11.7003H12.0003H12.1003V6.00156V6.10156L12.3003 7.90156C12.4003 8.60156 12.9003 9.10156 13.6003 9.10156C13.7003 9.10156 13.8003 9.10156 13.8003 9.10156L15.8003 9.00156L16.6003 17.7016Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 8.3H16.3002C15.4002 8.3 14.7002 7.6 14.7002 6.7V4L14.8002 4.1L19.0002 8.3Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0004 8.3V18.4C19.0004 19.3 18.3004 20 17.4004 20H8.50039C7.60039 20 6.90039 19.3 6.90039 18.4V5.6C6.90039 4.7 7.60039 4 8.50039 4H14.6004H14.7004V6.7C14.7004 7.6 15.4004 8.3 16.3004 8.3H19.0004Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 8.3V18.4C19.0002 19.3 18.3002 20 17.4002 20H9.3002C8.4002 20 7.7002 19.3 7.7002 18.4V5.6C7.7002 4.7 8.4002 4 9.3002 4H14.6002H14.7002V6.7C14.7002 7.6 15.4002 8.3 16.3002 8.3H19.0002Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 11H10.5C10.2 11 10 10.8 10 10.5C10 10.2 10.2 10 10.5 10H16.4C16.7 10 16.9 10.2 16.9 10.5C16.9 10.8 16.6 11 16.4 11Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 14H10.5C10.2 14 10 13.8 10 13.5C10 13.2 10.2 13 10.5 13H16.4C16.7 13 16.9 13.2 16.9 13.5C16.9 13.8 16.6 14 16.4 14Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 16.6016H10.5C10.2 16.6016 10 16.4016 10 16.1016C10 15.8016 10.2 15.6016 10.5 15.6016H13.8C14.1 15.6016 14.3 15.8016 14.3 16.1016C14.3 16.4016 14.1 16.6016 13.8 16.6016Z",
    fill: "url(#paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.6378,
    y1: 9.19992,
    x2: 13.4519,
    y2: 7.4643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.1961,
    y1: 4.49956,
    x2: 8.60729,
    y2: 15.2509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.4549,
    y1: 4.7099,
    x2: 13.1395,
    y2: 9.5421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 17.5077,
    y1: 8.2294,
    x2: 0.474091,
    y2: 22.3636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.6719,
    y1: 2.8036,
    x2: 2.6921,
    y2: 34.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 2.5697,
    y1: 10.3055,
    x2: 16.5623,
    y2: 10.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 2.5221,
    y1: 13.3131,
    x2: 16.5147,
    y2: 13.5345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 2.4803,
    y1: 15.9551,
    x2: 16.4729,
    y2: 16.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLesson, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Lesson.c26c6da1.svg";
export { ForwardRef as ReactComponent };